import React, { useRef, useState } from "react";
import "./UnsolicitedSamples.css";
import SearchInput from "../../../UIComponents/SearchInput/SearchInput";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  getSrtUnsolicitedSamplesList,
  massSearchFilter,
  resetMassUnsolicitedFilter,
  resetSeasonFilter,
  selectUnselectSrtTableRows,
  selectUnselectSrtTableRowWs,
  srtUnsolicitedBulkExport,
  srtUnsolicitedBulkUploadSave,
  UnsolicitedList,
  unsolicitedMassFilter,
} from "../../../Redux/actions/Srt/Srt";
import Select from "../../../UIComponents/DropDown/DropDown";
import { DownloadOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { SyncOutlined } from "@ant-design/icons";
import { toast } from "../../../UIComponents/Toast";
import UnsolicitedTable from "./UnsolicitedTable";
import { useLocation, useNavigate } from "react-router-dom";
const TOTAL_PER_PAGE = 100;
const CHUNK_SIZE = 25;
const UnsolicitedSamples = (containerRef) => {
  const dispatch = useDispatch();
  const fileRef = useRef();
  const [singleColor, setSingleColor] = useState([]);
  const [singleSeason, setSingleSeason] = useState([]);
  const [singleFactory, setSingleFactory] = useState([]);
  const [singleSize, setSingleSize] = useState([]);
  const [singleReference, setSingleReference] = useState([]);
  const [singleReceived, setSingleReceived] = useState([]);
  const [searchFilter, setSearchFilter] = useState(undefined);
  const [requestFilter, setRequestFilter] = useState(undefined);
  const [teamFilter, setTeamFilter] = useState(undefined);
  const [referenceFilter, setReferenceFilter] = useState(undefined);
  const [receivedFilter, setReceivedFilter] = useState(undefined);
  const [sizeFilter, setSizeFilter] = useState(undefined);
  const [colorFilter, setColorFilter] = useState(undefined);
  const [vendorFilter, setVendorFilter] = useState(undefined);

  const exportArraySrtIds = useSelector(
    (state) => state?.Srt?.srtSelectedTableRows
  );
  const srtRefresh = useSelector((state) => state?.Srt?.srtRefreshSpinner);
  const srtDataForApi = JSON.parse(localStorage.getItem("srtData"));
  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);

  let srtUnsolicitedListData = useSelector(
    (state) => state?.Srt?.srtUnsolicitedList
  );
  const massFilterApiData = useSelector(
    (state) => state?.Srt?.unsolicitedMassSearchFilterResult
  );
  const seasonFilterApiData = useSelector(
    (state) => state?.Srt?.seasonSearchFilterResult
  );
  const srtSeasonData = useSelector((state) => state?.Srt?.srtSeasonSearch);
  const UnsolicitedListData = useSelector(
    (state) => state?.Srt?.UnsolicitedList
  );
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [current, setCurrent] = useState(() => {
    const page = queryParams.get("page");
    return page ? parseInt(page) : 1;
  });

  const [pageCount, setPageCount] = useState(() => {
    const size = queryParams.get("pageSize");
    return size ? parseInt(size) : TOTAL_PER_PAGE;
  });

  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };
  useEffect(() => {
    dispatch(UnsolicitedList());
  }, []);

  useEffect(() => {
    const page = queryParams.get("page");
    const size = queryParams.get("pageSize");

    if (page && parseInt(page) !== current) {
      setCurrent(parseInt(page));
    }

    if (size && parseInt(size) !== pageCount) {
      setPageCount(parseInt(size));
    }
  }, [location.search]);

  const intialSearch = () => {
    if (UnsolicitedListData) {
      return UnsolicitedListData;
    } else return [];
  };
  useEffect(() => {
    const colorArray = intialSearch()?.map((item) => item?.color);
    setSingleColor([...new Set(colorArray)]);
    const sizeArray = intialSearch()?.map((item) => item?.size);
    setSingleSize([...new Set(sizeArray)]);
    const referenceArray = intialSearch()?.map(
      (item) => item?.reference_number
    );
    setSingleReference([...new Set(referenceArray)]);
    const receivedArray = intialSearch()?.map((item) => item?.date_received);
    setSingleReceived([...new Set(receivedArray)]);
  }, [intialSearch()]);

  useEffect(() => {
    const vendorArray = intialSearch()?.map((item) => item?.factory_name);
    const uniqueNames = new Set();

    if (Array.isArray(vendorArray)) {
      vendorArray.forEach((names) => {
        if (Array.isArray(names)) {
          names.forEach((name) => {
            uniqueNames.add(name);
          });
        } else {
          uniqueNames.add(names);
        }
      });
    }

    const uniqueArray = Array.from(uniqueNames).sort();

    setSingleFactory(uniqueArray);
  }, [intialSearch()]);

  const [massFilterData, setMassFilterData] = useState(() => {
    const savedData = localStorage.getItem("unsolicitedMassFilterData");
    return savedData
      ? { ...JSON.parse(savedData), brand: "" }
      : {
          searchFilter: "",
          vendorFilter: "",
          colorFilter: "",
          referenceFilter: "",
          sizeFilter: "",
          receivedFilter: "",
        };
  });
  const srtMassFilterData = JSON.parse(
    localStorage.getItem("unsolicitedMassFilterData")
  );
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [MM, DD, YYYY] = dateStr.split("/");
    return `${YYYY}-${MM}-${DD}`;
  };
  useEffect(() => {
    localStorage.setItem("srtActiveKey", "7");

    const hasActiveFilters =
      srtMassFilterData &&
      (srtMassFilterData.searchFilter ||
        srtMassFilterData.vendorFilter ||
        srtMassFilterData.colorFilter ||
        srtMassFilterData.referenceFilter ||
        srtMassFilterData.receivedFilter ||
        srtMassFilterData.sizeFilter);

    if (hasActiveFilters) {
      dispatch(
        unsolicitedMassFilter(
          srtMassFilterData.searchFilter || "",
          srtMassFilterData.vendorFilter || "",
          srtMassFilterData.colorFilter || "",
          srtMassFilterData.referenceFilter || "",
          srtMassFilterData.receivedFilter || "",
          srtMassFilterData.sizeFilter || "",
          current,
          pageCount
        )
      );
    } else {
      dispatch(getSrtUnsolicitedSamplesList(current, pageCount));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "unsolicitedMassFilterData",
      JSON.stringify(massFilterData)
    );
  }, [massFilterData]);

  const onSearchChange = (e) => {
    setSearchFilter(e.target.value);
    setMassFilterData((prevData) => ({
      ...prevData,
      searchFilter: e.target.value,
    }));
  };

  const onColorChange = (value) => {
    setColorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, colorFilter: value }));
  };

  const onSizeChange = (value) => {
    setSizeFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, sizeFilter: value }));
  };

  const onReceivedChange = (value) => {
    setReceivedFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, receivedFilter: value }));
  };

  const onSubmitClick = () => {
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    if (
      !searchFilter &&
      !vendorFilter &&
      !colorFilter &&
      !referenceFilter &&
      !receivedFilter &&
      !sizeFilter
    ) {
      toast.error("!Please select season");
    } else {
      dispatch(
        unsolicitedMassFilter(
          searchFilter ? searchFilter : "",
          vendorFilter ? vendorFilter : "",
          colorFilter ? colorFilter : "",
          referenceFilter ? referenceFilter : "",
          receivedFilter ? receivedFilter : "",
          sizeFilter ? sizeFilter : "",
          1,
          TOTAL_PER_PAGE
        )
      );
    }
  };

  const exportToExcelDickies = () => {
    dispatch(srtUnsolicitedBulkExport({ ids: exportArraySrtIds }));
    dispatch(selectUnselectSrtTableRows([]));
    dispatch(srtEXportArray([]));
  };

  const onRefresh = () => {
    // Clear localStorage
    localStorage.removeItem("unsolicitedMassFilterData");
    localStorage.removeItem("massFilterData");
    localStorage.removeItem("currentPage");

    // Reset all state variables to their initial values
    setSearchFilter(undefined);
    setRequestFilter(undefined);
    setReferenceFilter(undefined);
    setVendorFilter(undefined);
    setSizeFilter(undefined);
    setColorFilter(undefined);
    setReceivedFilter(undefined);
    setTeamFilter(undefined);

    // Reset the massFilterData state to initial values
    setMassFilterData({
      searchFilter: "",
      vendorFilter: "",
      colorFilter: "",
      referenceFilter: "",
      sizeFilter: "",
      receivedFilter: "",
    });

    // Reset pagination
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);

    // Update localStorage with clean data
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "",
        style: "",
        factory: "",
        rejected_date: "",
        sale_sample: 0,
      })
    );

    localStorage.setItem(
      "unsolicitedMassFilterData",
      JSON.stringify({
        searchFilter: "",
        vendorFilter: "",
        colorFilter: "",
        referenceFilter: "",
        receivedFilter: "",
        sizeFilter: "",
      })
    );

    // Dispatch actions to refresh data
    dispatch(getSrtUnsolicitedSamplesList(1, TOTAL_PER_PAGE));
    updateQueryParams(1, TOTAL_PER_PAGE);
    dispatch(resetSeasonFilter([]));
    dispatch(resetMassUnsolicitedFilter([]));

    // Clear any selected rows
    dispatch(selectUnselectSrtTableRows([]));
  };

  const onFactoryChange = (value) => {
    setVendorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, vendorFilter: value }));
  };

  const onSearchEnter = (event) => {
    if (event.key === "Enter") {
      if (searchFilter === null) {
        toast.error("Please Enter Details");
      } else {
        setCurrent(1);
        setPageCount(TOTAL_PER_PAGE);
        updateQueryParams(1, TOTAL_PER_PAGE);
        localStorage.setItem(
          "srtMassData",
          JSON.stringify({
            searchFilter: searchFilter,
            brandfilter: "",
            requestfilter: "",
            teamFilter: "",
            referenceFilter: "",
            vendorFilter: "",
            sale_samplefilter: 0,
          })
        );
        dispatch(
          unsolicitedMassFilter(
            searchFilter ? searchFilter : "",
            "",
            "",
            "",
            "",
            "",
            1,
            TOTAL_PER_PAGE
          )
        );
        setSearchFilter();
      }
    }
  };

  const onSrtBulkUpload = (e) => {
    let formData = new FormData();
    formData.append("files", e.target.files[0]);
    dispatch(srtUnsolicitedBulkUploadSave(formData, brandNameFromApi));
    e.target.value = null;
    formData = new FormData();
  };

  return (
    <div className="dickies-main-container">
      <div className="dickies-first-two-dropdowns">
        <div></div>
        <h2>UNSOLICITED SAMPLES</h2>

        <div className="dickies-drop-down-two">
          <Button icon={<DownloadOutlined />} onClick={exportToExcelDickies}>
            Export
          </Button>
        </div>
      </div>
      <div className="search-dropdown-button">
        <div className="sync-icon">
          {/* <SyncOutlined spin={srtRefresh} onClick={onRefresh} /> */}
        </div>
        <div>
          <Button
            className="dickies-button"
            onClick={() => fileRef.current.click()}
          >
            Bulk Update
          </Button>
          <input
            type="file"
            onChange={onSrtBulkUpload}
            accept="image/jpeg/png/jpg , application/pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ref={fileRef}
            hidden
          />
        </div>
      </div>
      <div className="search-dropdown-button">
        <div className="dickies-search-input">
          <SearchInput
            // maxLength={10}
            onKeyPress={onSearchEnter}
            onChange={onSearchChange}
            value={searchFilter}
            placeholder={"Search by Vendor, color, size or received date."}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
            }}
          />
        </div>
        <div className="unsolicited-dropdown-width unsolicited-dickies-drop-down-one">
          <Select
            allowClear
            placeholder={"Vendor"}
            data={singleFactory}
            value={vendorFilter}
            onChange={onFactoryChange}
          ></Select>
        </div>
        <div className="unsolicited-dropdown-width unsolicited-dickies-drop-down-two">
          <Select
            allowClear
            placeholder={"Color"}
            data={singleColor}
            value={colorFilter}
            onChange={onColorChange}
          ></Select>
        </div>
        <div className="unsolicited-dropdown-width unsolicited-dickies-drop-down-three">
          <Select
            allowClear
            placeholder={"Size"}
            data={singleSize}
            value={sizeFilter}
            onChange={onSizeChange}
          ></Select>
        </div>
        <div className="unsolicited-dropdown-width unsolicited-dickies-drop-down-four">
          {/* <Select
            allowClear
            placeholder={"Reference Number"}
            data={singleReference}
            value={referenceFilter}
            onChange={onReferenceChange}
          ></Select> */}
        </div>
        <div className="unsolicited-dropdown-width unsolicited-dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Received Filter"}
            data={singleReceived}
            value={receivedFilter}
            onChange={onReceivedChange}
          ></Select>
        </div>
        <div className="sync-icon">
          <SyncOutlined spin={srtRefresh} onClick={onRefresh} />
        </div>
        <div>
          <Button
            onClick={onSubmitClick}
            className="dickies-button"
            children={"SUBMIT"}
          />
        </div>
      </div>
      <div className="srt-table-container">
        <UnsolicitedTable
          data={massFilterData}
          current={current}
          pageCount={pageCount}
          setCurrent={setCurrent}
          setPageCount={setPageCount}
          totalPerPage={TOTAL_PER_PAGE}
          chunkSize={CHUNK_SIZE}
          containerRef={containerRef}
        />
      </div>
    </div>
  );
};

export default UnsolicitedSamples;
